import React from 'react'
import { Link } from 'react-router-dom'
import { useDispatch } from 'react-redux'

import { login } from '../../reducers/authReducer'

import { Form, Input, Button, Checkbox, Divider } from 'antd'
import { MailOutlined, LockOutlined, GoogleOutlined, GithubOutlined } from '@ant-design/icons'

import {
  FormItemFlex,
  PageContainer,
  FormContainer,
  FormWrapper,
  FormTitle,
  FormSubtitle,
  StyledForm,
  HomeLink
} from './style'
import { HomeOutlined } from '@ant-design/icons'

const Login = () => {
  const dispatch = useDispatch()

  const onFinish = (values) => {
    if (values.remember) {
      window.localStorage.setItem(
        'WiseAcademy-remember-cred',
        JSON.stringify({ remember: values.remember, email: values.email })
      )
    } else {
      window.localStorage.setItem(
        'WiseAcademy-remember-cred',
        JSON.stringify({ remember: false })
      )
    }
    dispatch(login(values))
  }

  const getInitialValues = () => {
    return JSON.parse(window.localStorage.getItem('WiseAcademy-remember-cred'))
  }

  return (
    <PageContainer>
      <FormContainer>
        <FormWrapper>
          <StyledForm
            name="login"
            onFinish={onFinish}
            initialValues={getInitialValues()}
            scrollToFirstError
          >
            <FormTitle>Sign In</FormTitle>
            <FormSubtitle>Welcome back! Please sign in to continue</FormSubtitle>

            <p style={{ textAlign: 'center', color: '#9CA3AF', fontSize: '0.875rem', marginBottom: '2rem' }}>
              New user? <Link to="/register" style={{ color: 'hsl(33, 100%, 50%)', textDecoration: 'none' }}>Create Account</Link>
              <span style={{ margin: '0 12px', color: '#4B5563' }}>|</span>
              <Link to="/" style={{ color: '#9CA3AF', textDecoration: 'none', display: 'inline-flex', alignItems: 'center', gap: '4px' }}>
                <HomeOutlined /> Return to Home
              </Link>
            </p>

            <Form.Item
              name="email"
              rules={[
                {
                  type: 'email',
                  message: 'The input is not valid E-mail!'
                },
                {
                  required: true,
                  message: 'Please input your E-mail!'
                }
              ]}
            >
              <Input prefix={<MailOutlined />} placeholder="E-Mail" />
            </Form.Item>

            <Form.Item
              name="password"
              rules={[
                {
                  required: true,
                  message: 'Please input your password!'
                }
              ]}
              hasFeedback
            >
              <Input.Password
                prefix={<LockOutlined />}
                placeholder="password"
              />
            </Form.Item>

            <FormItemFlex>
              <Form.Item name="remember" valuePropName="checked" noStyle>
                <Checkbox>Remember me</Checkbox>
              </Form.Item>
              {/* <Link to="/ForgetPassword">Forget Password</Link> */}
            </FormItemFlex>

            <Form.Item>
              <Button block type="primary" htmlType="submit">
                Login
              </Button>
            </Form.Item>

            <Divider plain>Or</Divider>

            <Form.Item>
              <Button
                block
                icon={<img src="https://www.gstatic.com/images/branding/product/1x/gsa_512dp.png" alt="Google" style={{ width: '18px', marginRight: '8px', verticalAlign: 'middle' }} />}
                onClick={() => {
                  const backendUrl = process.env.REACT_APP_API_URL || 'https://wiseacademybackend.vercel.app'
                  window.location.href = `${backendUrl}/users/auth/google`
                }}
                style={{ marginBottom: '8px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
              >
                Sign in with Google
              </Button>
            </Form.Item>

            <Form.Item>
              <Button
                block
                icon={<img src="https://github.githubassets.com/images/modules/logos_page/GitHub-Mark.png" alt="GitHub" style={{ width: '18px', marginRight: '8px', verticalAlign: 'middle' }} />}
                onClick={() => {
                  const backendUrl = process.env.REACT_APP_API_URL || 'https://wiseacademybackend.vercel.app'
                  window.location.href = `${backendUrl}/users/auth/github`
                }}
                style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
              >
                Sign in with GitHub
              </Button>
            </Form.Item>
          </StyledForm>
        </FormWrapper>
      </FormContainer>
    </PageContainer>
  )
}
export default Login
